'use strict';

var isPrimaryPointer = require('../../../../../../motion-dom/dist/es/gestures/utils/is-primary-pointer.cjs');

function extractEventInfo(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY,
        },
    };
}
const addPointerInfo = (handler) => {
    return (event) => isPrimaryPointer.isPrimaryPointer(event) && handler(event, extractEventInfo(event));
};

exports.addPointerInfo = addPointerInfo;
exports.extractEventInfo = extractEventInfo;
//# sourceMappingURL=event-info.cjs.map
